import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import Button from "../../components/CustomButton/CustomButton.jsx";
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import { confirmAlert } from 'react-confirm-alert'; 


const restLink_flavor = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
 });
const flavor_client = new ApolloClient({
  link: restLink_flavor,
  cache: new InMemoryCache(),
});

function getUrl($param, $param_1 = null,$param_2 = null) {
  var $url = "/#/"+$param;
  if($param_1 != null) {
    $url += "/"+$param_1;
  }
  if($param_2 != null) {
    $url += "/"+$param_2;
  }
  return $url;
}


const GET_FLAVOR = gql`
{
  flavors_collections{
    flavors{
      id
      title
      ram
      vcpu
      cost_format
    }
  }
}
`;

const COUNT_FLAVOR = gql`query countFlavor($search: String!){
  flavor_count(search:$search){
    count
  }
}
`;


const DELETE_FLAVOR = gql`
   mutation deleteFlavor($id: Int!){
     deleteFlavor(id:$id) {
       id
     }
   }
 `;


class FlavorList extends Component {


  state = {
    search: '',
    limit: 20,
    page: 1,
    orderby: "id",
    order: "DESC"
  }

  toggleOrder = (event) => {
    this.setState({
      order: (this.state.order == 'DESC'? 'ASC' : 'DESC')
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      search: event.target.elements.search.value,
      order: event.target.elements.order.value,
      orderby: event.target.elements.orderby.value
    });

  }

  render() {
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <NavLink
                  to={'/Flavor-new/'}
                  className="btn btn-info btn-fill"
                  activeClassName=""
                >
                Criar Modelo
              </NavLink>
              <Card
                title={"Modelos ativos"}
                flavor="Gerenciar Modelos"
                ctTableFullWidth
                ctTableResponsive
                content={
                  
                  <Table striped hover>
                    <thead>
                      <tr>
                      <th colSpan={9}>
                            <form 
                            onSubmit={e => {
                              this.handleSubmit(e);
                              e.preventDefault();
                            }}
                            >
                              <Row>
                                  <Col md={6} lg={3}>
                                      <input  type="text" name="search" className="form-control" />
                                  </Col>
                                  <Col md={2}>
                                    <Button bsStyle="info" fill type="submit" >
                                      Buscar
                                    </Button>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6} lg={1}>
                                      <select name="orderby" className="form-control">
                                        <option value="id">ID</option>
                                        <option value="title">Título</option>
                                      </select>
                                  </Col>
                                  <Col md={6} lg={2}>
                                      <select name="order" className="form-control">
                                        <option value="DESC">Decrescente</option>
                                        <option value="ASC" selected={this.state.order == "ASC"}>Crescente</option>
                                      </select>
                                  </Col>
                                  <Col md={2}>
                                    <Button bsStyle="info" fill type="submit" >
                                      Ordenar
                                    </Button>
                                  </Col>
                                </Row>
                            </form>
                        </th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>Nome do Modelo</th>
                        <th>RAM</th>
                        <th>vCPU</th>
                        <th>Valor</th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                        <Query
                          client={flavor_client}
                          query={GET_FLAVOR}
                          fetchPolicy='no-cache'
                          /*
                          variables={{
                            search: this.state.search, 
                            limit: this.state.limit, 
                            page: this.state.page, 
                            order: this.state.order, 
                            orderby: this.state.orderby
                          }}
                          */
                        >
                          {({ loading, error, data }) => {
                            if (loading) return <tr><td>Carregando...</td></tr>;
                            if (error) return <tr><td>Erro :(</td></tr>;
                              
                              if(!data.flavors_collections) {
                                return (<tr><td>(Vazio)</td></tr>);
                              } 

                              return data.flavors_collections.flavors.map((item) => (
                              
                              <tr key={item.id}>
                                <td>{item.title}</td>
                                <td>{item.ram / 1024} GB</td>
                                <td>{item.vcpu}</td>
                                <td>R$ {item.cost_format}</td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('ClusterHasFlavor',item.id)}>Clusters</a>
                                </td>
                                <td>
                                  <a className="btn btn-info" href={getUrl('Flavor-edit',item.id)}>Editar</a>
                                </td>
                                <td>
                                <Button bsStyle="danger" onClick={() => {
                                       var r = confirmAlert({
                                       title: '',
                                       message: "Tem certeza que deseja excluir "+item.title,
                                       buttons: [
                                         {
                                           label: 'Sim',
                                           onClick: () => {
                                             // Delete item
                                             flavor_client.mutate({
                                               mutation: DELETE_FLAVOR,
                                               variables: {
                                                 id:item.id
                                               }
                                             }).then(
                                              result => {
                                                 window.location.reload();
                                             });
                                           }
                                         },
                                         {
                                           label: 'Não'
                                         }
                                       ]
                                     });
                                    
                                  }}>
                                  Excluir
                                </Button>
                                </td>
                              </tr>
                            ));
                          }}
                        </Query>
                       
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default FlavorList;
